import { Box, Flex, FormLabel, Text, Tooltip } from '@chakra-ui/react'
import { QuestionMarkIcon } from '../QuestionMarkIcon'

export const SliderLabel = ({
  label,
  additionalButton,
  value,
  onClick,
  tooltip
}: {
  label: string
  additionalButton?: React.ReactNode
  value?: string | number | boolean | React.ReactNode
  onClick?: () => void
  tooltip?: string | React.ReactNode
}) => (
  <Flex sx={{ w: '100%', justifyContent: 'space-between' }}>
    <Flex sx={{ gap: 4, alignItems: 'center' }}>
      <FormLabel onClick={onClick}  >{label}</FormLabel>

      {tooltip && (
        <Tooltip hasArrow label={tooltip} placement="top">
          <Box sx={{ lineHeight: 0 }}>
            <QuestionMarkIcon ml={2} />
          </Box>
        </Tooltip>
      )}

      {additionalButton && additionalButton}
    </Flex>

    {typeof value !== 'undefined' && (
      <Text sx={{ fontSize: 'md', fontWeight: 'bold' }}>{value}</Text>
    )}
  </Flex>
)
